import "./videoPlayer.css";
import intro from "./intro.mp4";
import video0 from "./video0.mp4";
import video1 from "./video1.mp4";
import video2 from "./video2.mp4";
import video3 from "./video3.mp4";
import video4 from "./video4.mp4";
import ReactPlayer from "react-player";
import { useState } from "react";
import { Pagination } from "./../Pagination/Pagination";
import muteIcon from "./../../assets/icons/mute.svg";
import UnMuteIcon from "./../../assets/icons/unmute.svg";

export function VideoPlayer({ videoId }) {
  const [current, setCurrent] = useState(1);
  const [isMute, setIsMute] = useState(true);
  const videoList = [intro, video0, video1, video2, video3, video4];

  return (
    <div className="wrapper">
      <div className="video-player">
        <div onClick={() => setIsMute(!isMute)}>
          <ReactPlayer
            key={current}
            className="react-player"
            url={videoList[current - 1]}
            playing={true}
            fullscreen={"fullscreen"}
            width={"100%"}
            height={"100%"}
            muted={isMute}
          />
          <img
            onClick={() => setIsMute(!isMute)}
            width={"50px"}
            src={isMute ? muteIcon : UnMuteIcon}
            alt="mute"
          />
        </div>
      </div>
      <Pagination current={current} setCurrent={setCurrent} />
    </div>
  );
}

// intro video
// https://www.youtube.com/watch?v=xB6Q_o2-jcE

// video0
// https://youtu.be/Twa7rqZuhAo

// video1
// https://youtu.be/_VgoUVZMMoo

// video2
// https://youtu.be/6U5sefCrNyI

// video3
// https://youtu.be/18wcFPRL9G0

// video4
// https://youtu.be/iEpj9iI-XKk
